module.exports = __webpack_public_path__ + "img/web-P4-3.812753bf.png";